import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function EnrollSection() {
  const navigate = useNavigate();
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-[#2563EB] rounded-[30px] shadow-xl px-8 md:px-14 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-8"
        >
          {/* Left Content */}
          <div className="text-center md:text-left">
            <motion.h2
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="text-white text-3xl md:text-4xl font-bold"
            >
              Have a project in your mind?
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="text-blue-100 text-lg mt-4"
            >
              Let's build something amazing together.
            </motion.p>
          </div>

          {/* Button */}
          <motion.button
            onClick={() => navigate("/contact")}
            whileHover={{
              scale: 1.05,
              backgroundColor: "#F8FAFC",
            }}
            whileTap={{ scale: 0.95 }}
            className="bg-white text-gray-700 font-semibold text-xl px-10 py-5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Get Started
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}